import React from 'react';
import TabsSection from '../../components/TabSection';

const Solutions2 = () => {
  const cardData = [
    {
      title: "ERP",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744400362/image_30_jxrki9.png",
    },
    {
      title: "OPPORTUNITIES",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744419425/image_wfhwdx.png",
    },
    {
      title: "Community",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744419425/image-1_dfwykn.png",
    },
  ];

  return (
    <div className="bg-white">
      <div className="md:px-28 px-4 md:pt-6 pt-2 md:pb-14 pb-4">
        <TabsSection />
        <h1 className="text-[14px] md:text-[36px] font-bold md:mt-6 mt-2 text-[#FDBD26]">EDUCATION</h1>
        <h1 className="text-[12px] md:text-[36px] font-normal md:mb-4 mb-2 md:mt-2 mt-1 text-black">
          What are the solutions and benefits that farmers get from Farmnet App
        </h1>
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744472650/image-7_o5hbbq.png"
          alt="Securing Agriculture in Namibia"
          className="w-full md:h-[480px] object-cover md:rounded-lg rounded-md transition-opacity duration-500"
        />

        {/* Benefits Section Header */}
        <h2 className="font-inter font-bold text-[14px] md:text-[32px] md:mt-8 mt-4">Benefits</h2>

        {/* Benefits Cards */}
        {cardData.map((card, index) => (
          <div key={index} className="flex md:flex-row justify-between items-start md:mt-6 mt-2 gap-4">
            {/* Left Text Section */}
            <div className="flex-1">
              <h2 className="font-inter font-bold text-[12px] md:text-[32px] mb-2">{card.title}</h2>
              <p className="font-inter font-normal text-[8px] md:text-[21px] leading-relaxed mb-7 tracking-tight" style={{ lineHeight: '1.25' }}>
                ERP stands for Enterprise Resource Planning. It is a type of software used by organizations to manage and integrate important parts of their business operations. An ERP system helps streamline processes by automating and collecting data across different business functions such as:
                <ul className="mt-2">
                  <li className='md:mb-4 mb-2'>Finance: Managing accounting, budgeting, and financial reporting.</li>
                  <li className='md:mb-4 mb-2 md:flex hidden'>Human Resources (HR): Managing employee data, payroll, recruitment, and performance.</li>
                  <li className='md:mb-4 mb-2 md:flex hidden'>Supply Chain Management: Managing inventory, procurement, logistics, and distribution.</li>
                  <li className='md:mb-4 mb-2 md:flex hidden'>Manufacturing: Overseeing production planning, scheduling, and quality control.</li>
                  <li className='md:mb-4 mb-2 md:flex hidden'>Sales and Customer Relationship Management (CRM): Managing sales orders, customer information, and marketing efforts.</li>
                </ul>
                <p className="mt-4">
                  By providing a unified platform, ERP systems improve data accuracy, efficiency, and decision-making across an organization.
                </p>
              </p>
            </div>

            {/* Right Image Box */}
            <div className="md:w-[280px] w-[100px] h-[180px] md:h-[470px] bg-[#D9D9D9] rounded-tr-[5px] rounded-br-[5px] flex items-center justify-center">
              <img
                src={card.image}
                alt={card.title}
                className="md:w-[128px] md:h-[128px] w-[60px] h-[60px] object-contain rounded-tr-[5px] rounded-br-[5px]"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Solutions2;
